module.exports = __webpack_public_path__ + "img/C-Malleoli180_ok.323334c9.png";